import * as types from './constants';

// Create Code Basic
export const createCodeBasicRequest = data => (
  { type: types.CREATE_CODE_BASIC_REQUEST, payload: data }
);

export const createCodeBasicDone = data => (
  { type: types.CREATE_CODE_BASIC_DONE, payload: data }
);

export const createCodeBasicFailed = errors => (
  { type: types.CREATE_CODE_BASIC_FAILED, payload: errors }
);

export const createCodeBasicReset = () => (
  { type: types.CREATE_CODE_BASIC_RESET }
);